import { observable, action /*computed,*/ } from 'mobx';
import { pluginStoreApi } from 'Api/index';
import { convertUTCToLocale } from '@/utils/date';
import { store } from 'Store/store.index';

export default class PluginStore {
  @observable loadFailedPlugin = [];
  @observable manifest = null;
  @observable category_id = '';
  @observable plugin_name = '';
  @observable plugin_name_sort = '';
  @observable defaultCategory = 'all';
  @observable isShowUploadPluginModal = false;
  @observable activeTab = 1;
  @observable pluginMetaData = {};
  @observable perPage = 5;
  @observable myPluginPageCount = null;
  @observable pluginStorePageCount = null;
  @observable currentPluginStorePage = 1;
  @observable currentMyPluginPage = 1;
  @observable pluginCategory = {};
  @observable pluginCommonDialog = {
    isShowPluginCommonDialog: false,
    width: '790px',
    title: 'plugin dialog',
    url: '', // iframe url
  }
  @observable pluginStoreListData = {
    list: [],
    pageCount: null,
  };
  @observable myPluginListData = {
    list: [],
    pageCount: null,
  };
  @action doAppendLoadFailedPlugin(pluginList, isReplace) {
    if (isReplace) {
      this.loadFailedPlugin = pluginList

      return
    }

    this.loadFailedPlugin = [...this.loadFailedPlugin, ...pluginList];
  }
  @action doUpdateMyPluginList(pluginList) {
    this.myPluginListData.list = pluginList;
  }
  @action resetData() {
    this.manifest = null;
    this.category_id = '';
    this.plugin_name = '';
    this.plugin_name_sort = '';
    this.defaultCategory = 'all';
    this.isShowUploadPluginModal = false;
    this.activeTab = 1;
    this.pluginMetaData = {};
    this.perPage = 5;
    this.myPluginPageCount = null;
    this.pluginStorePageCount = null;
    this.currentPluginStorePage = 1;
    this.currentMyPluginPage = 1;
    this.pluginCategory = {};
    this.pluginStoreListData = {
      list: [],
      pageCount: null,
    };
    this.myPluginListData = {
      list: [],
      pageCount: null,
    };
  }
  @action initialize() {
    pluginStoreApi.initialize();
  }
  @action doUpdateManifest(value) {
    this.manifest = value;
  }
  @action onShowPluginDetail(activeTab, pluginMetaData) {
    this.doUpdateActiveTab(activeTab);
    this.doUpdatePluginMetaData(pluginMetaData);
  }
  @action doUpdatePluginName(value) {
    this.plugin_name = value;
  }
  @action doUpdateCategoryId(value) {
    this.category_id = value;
  }
  @action doUpdateCurrentMyPluginPage(value) {
    this.currentMyPluginPage = value;
  }
  @action doUpdateCurrentPluginStorePage(value) {
    this.currentPluginStorePage = value;
  }
  @action doUpdateShowUploadPluginModal(value) {
    this.isShowUploadPluginModal = value;
  }
  @action doUpdateActiveTab(value) {
    this.activeTab = value;
  }
  @action doUpdatePluginMetaData(value) {
    this.pluginMetaData = value;
  }
  @action async doGetPluginCategory() {
    try {
      let res = await pluginStoreApi.doGetPluginCategory();

      if (res.ret === 0) {
        this.pluginCategory = res.data;
      }

      return res;
    } catch (error) {
      throw error;
    }
  }
  @action async doGetUserPluginList(isAppend) {
    try {
      const perPage = this.perPage;
      const currentPage = this.currentMyPluginPage;
      const plugin_name_sort = this.plugin_name_sort;
      const plugin_name = this.plugin_name;
      const userToken = store.userStore.token;
      const res = await pluginStoreApi.doGetUserPluginList({ userToken, plugin_name_sort, plugin_name, perPage, currentPage });

      if (res.ret === 0) {
        res.data.list.forEach((item) => {
          item.config_text = JSON.parse(item.config_text);
          item.created = convertUTCToLocale(item.created * 1000);
          item.updated = convertUTCToLocale(item.updated * 1000);
        });

        const myPluginListData = {
          list: isAppend ? [...this.myPluginListData.list, ...res.data.list] : res.data.list,
          pageCount: res.data.pageCount,
        };

        this.myPluginListData = myPluginListData;
      }

      return res;
    } catch (error) {
      throw error;
    }
  }
  @action async doGetPluginStoreList(isAppend) {
    try {
      const plugin_name = this.plugin_name;
      const category_id = this.category_id === 'all' ? '' : this.category_id;
      const perPage = this.perPage;
      const currentPage = this.currentPluginStorePage;
      const res = await pluginStoreApi.doGetPluginStoreList({ category_id, plugin_name, perPage, currentPage });

      if (res.ret === 0) {
        res.data.list.forEach((item) => {
          item.config_text = JSON.parse(item.config_text);
          item.created = convertUTCToLocale(item.created * 1000);
          item.updated = convertUTCToLocale(item.updated * 1000);
        });

        const pluginStoreListData = {
          list: isAppend ? [...this.pluginStoreListData.list, ...res.data.list] : res.data.list,
          pageCount: res.data.pageCount,
        };

        this.pluginStoreListData = pluginStoreListData;
      }

      return res;
    } catch (error) {
      throw error;
    }
  }
  @action async doInstallPlugin({ plugin_id }) {
    try {
      const userToken = store.userStore.token;
      const res = await pluginStoreApi.doInstallPlugin({ userToken, plugin_id });

      return res;
    } catch (error) {
      throw error;
    }
  }
  @action async doModifyUserPlugin({ plugin_id, status, is_remove }) {
    try {
      const userToken = store.userStore.token;
      const res = await pluginStoreApi.doModifyUserPlugin({ userToken, plugin_id, status, is_remove });

      return res;
    } catch (error) {
      throw error;
    }
  }
  @action onSortMyPlugin(isDesc) {
    let myPluginList = this.myPluginListData.list.splice(0);

    myPluginList.sort((item1, item2) => {
      const firstItem = item1.plugin_name.toLowerCase();
      const secondItem = item2.plugin_name.toLowerCase();

      if (isDesc) {
        if (firstItem > secondItem) {
          return -1;
        }
      } else {
        if (firstItem < secondItem) {
          return -1;
        }
      }
    });

    this.myPluginListData.list = myPluginList;
  }
}
